export const CARRIER_LISTINGS = "CARRIER_LISTINGS";

export const _carrierListingsAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: CARRIER_LISTINGS,
      payload: data,
    });
  };
};